import { render, staticRenderFns } from "./AddPermissionForUserDialog.vue?vue&type=template&id=f6cb7cca&scoped=true"
import script from "./AddPermissionForUserDialog.vue?vue&type=script&lang=js"
export * from "./AddPermissionForUserDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPermissionForUserDialog.vue?vue&type=style&index=0&id=f6cb7cca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cb7cca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6cb7cca')) {
      api.createRecord('f6cb7cca', component.options)
    } else {
      api.reload('f6cb7cca', component.options)
    }
    module.hot.accept("./AddPermissionForUserDialog.vue?vue&type=template&id=f6cb7cca&scoped=true", function () {
      api.rerender('f6cb7cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AddPermissionForUserDialog.vue"
export default component.exports